import React from "react";
import ReactDOM from "react-dom";

import App from "./App";
import { MsalProvider } from "@azure/msal-react";
import { EventType, PublicClientApplication, AccountInfo, EventMessage } from "@azure/msal-browser";
import config, { isMsal } from "./config";

import "./styles/styles.css";
import "react-widgets/styles.css";

// dayjs setup
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import customParseFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";

dayjs.extend(utc);
dayjs.extend(customParseFormat);
dayjs.extend(duration);
//----

let app: React.ReactElement;
export let msalInstance: PublicClientApplication;

if (isMsal) {
    msalInstance = new PublicClientApplication({
        auth: {
            ...config.msal,
            clientId: config.msal.clientId!,
        }
    });

    // Default to using the first account if no account is active on page load
    if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
        // Account selection logic is app dependent. Adjust as needed for different use cases.
        msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
    }

    // Optional - This will update account state if a user signs in from another tab or window
    msalInstance.enableAccountStorageEvents();

    msalInstance.addEventCallback((event: EventMessage) => {
        if (event.eventType === EventType.LOGIN_SUCCESS) {

            const payload = event.payload as { account?: AccountInfo } | null;

            if (payload?.account) {
                msalInstance?.setActiveAccount(payload.account);
            }
        }
    });

    app = (
        <MsalProvider instance={msalInstance} >
            <App />
        </MsalProvider>
    );
} else {
    app = <App />;
}

ReactDOM.render(app, document.getElementById("root"));